import { Button, Dialog, DialogActions, DialogContent, InputAdornment } from "@material-ui/core";
import { Field, Form, Formik } from "formik";
import { useActivation } from "lib/hooks/useActivation";
import React, { FC, useMemo } from "react";
import { object, string } from "yup";
import { FrontDialogTitle } from "components/front/Form/FrontDialogTitle";
import { AaTextField } from "components/front/layout/aniale/AaTextField";
import { SsDialogOpenButton } from "components/front/layout/SsDialogOpenButton";
import { Order } from "interfaces/front/page/mypage/supportPanel";

export const ReceiptArea: FC<{ order: Pick<Order, "order_payment" | "status" | "code"> }> = ({ order }) => {
  const [opened, open, close] = useActivation(false);
  const canIssueReceipt = useMemo(() => {
    const paymentMethod = order.order_payment.payment_method;
    return paymentMethod.match(/credit_card|bank/) && order.status === "completed";
  }, [order]);
  return canIssueReceipt ? (
    <>
      <SsDialogOpenButton label="領収書を発行する" onClick={open} margin="20px auto" />
      <ReceiptDialog opened={opened} close={close} orderCode={order.code} />
    </>
  ) : (
    <></>
  );
};

const ReceiptDialog: FC<{
  opened: boolean;
  close: () => void;
  orderCode: string;
}> = ({ opened, close, orderCode }) => {
  return (
    <Dialog open={opened} onClose={close} fullWidth>
      <Formik<{ order_code: string; address_name: string }>
        initialValues={{ order_code: orderCode, address_name: "" }}
        onSubmit={async (_, { setSubmitting }) => {
          close();
          setSubmitting(false);
        }}
        validationSchema={object().shape({
          address_name: string().max(50, "50文字以下で入力してください"),
        })}
      >
        {({ isSubmitting, submitForm }): React.ReactNode => (
          <Form action="/receipt/issue" method="get" target="_blank" onSubmit={submitForm}>
            <FrontDialogTitle title="" onClose={close} />
            <DialogContent>
              <div>領収書の宛名を入力してください</div>
              <Field
                component={AaTextField}
                variant="outlined"
                name="address_name"
                fullWidth
                margin="normal"
                InputProps={{
                  endAdornment: <InputAdornment position="end">様</InputAdornment>,
                }}
              />
              <Field type="hidden" name="order_code" />
            </DialogContent>
            <DialogActions>
              <Button type="submit" disabled={isSubmitting} fullWidth variant="contained" color="primary">
                発行する
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};
